import {getDictionary} from 'api/debtCollectionMonitor';

export const DICT_LOAD = 'DICT_LOAD';

export const load = () => async dispatch => {
  const dictionaries = await getDictionary();
  dispatch({type: DICT_LOAD, payload: dictionaries});
};


// WEBPACK FOOTER //
// ./src/actions/dictionary.js